import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import {settings} from "routes";
import styles from "assets/jss/llv/layouts/adminStyle.js";
import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/images/logoYnovWhite.png";
import  AjouterBranche  from "pages/Settings/Branche/AjouterBranche";
import { connect } from "react-redux";
import AddUtilisateur from "pages/Settings/Utilisateur/AddUtilisateur";
import UpdateUtilisateur from "pages/Settings/Utilisateur/UpdateUtilisateur";

let ps;

const switchRoutes = (
  <Switch>
     <Route path="/settings/utilisateur/add" component={AddUtilisateur} name='Nouvel utilisateur' />
     <Route path="/settings/branche/add" component={AjouterBranche} name='Nouvelle branche' />
     <Route path="/settings/utilisateur/update/:id" component={UpdateUtilisateur} name='Modifier un utilisateur' />
     
    {settings.map((prop, key) => {
      if (prop.layout === "/settings") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
     
     <Redirect from="/settings" to="/settings/utilisateur" />
  </Switch>
);

const useStyles = makeStyles(styles);

function Settings({ui: { layoutRoot },user:{credentials}, ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("green");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  
  const handleImageClick = image => {
    setImage(image);
  };
  
  const handleColorClick = color => {
    setColor(color);
  };
  
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={settings}
        logoText={"ENOV APP"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={settings}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>
              {switchRoutes}
             
            </div>
          </div>
        ) : (
          <div className={classes.map}>
            {switchRoutes}
          </div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  ui: state.UI,
  user: state.user
});

const mapActionsToProps = {}
export default connect(mapStateToProps, mapActionsToProps)(Settings)